import { TOGGLE_MENU_CONTEXT, UPDATE_CURRENT_PATIENT } from './types';

export function toggleMenuContext(context) {
  return {
    type: TOGGLE_MENU_CONTEXT,
    context
  };
}

export function updateCurrentPatient(context) {
  return{
    type: UPDATE_CURRENT_PATIENT,
    context
  };
}